import { render, staticRenderFns } from "./right_10.vue?vue&type=template&id=d1bb2bd4&scoped=true&"
import script from "./right_10.vue?vue&type=script&lang=js&"
export * from "./right_10.vue?vue&type=script&lang=js&"
import style0 from "./right_10.vue?vue&type=style&index=0&id=d1bb2bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bb2bd4",
  null
  
)

export default component.exports